import React from 'react';
import { connect } from 'react-redux';
import AccountImage from '../../components/Image/AccountImage'
import Api from '../../api/Api.js';
import CustomerEndpoints from '../../api/CustomerEndpoints';
import { store } from '../../redux/store';
import { SET_CUSTOMER_LIST } from '../../redux/types';
import { push } from 'connected-react-router';
import DataTable from '../../components/Table/DataTable';

const columns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "Costing Center",
        options: {
            filter: true,
            sort: false,
            download: true,
            display: "excluded"
        }
    },
    {
        name: "Logo",
        options: {
            filter: false,
            sort: false,
            download: false
        }
    },
    {
        name: "Account Number",
        options: {
            filter: false,
            sort: true,
        }
    },
    {
        name: "Company Name",
        options: {
            filter: false,
            sort: true,
        }
    }
];

class SearchCustomer extends React.Component {

    options = {
        onRowClick: (row) => store.dispatch(push('/customers/view/' + row[0]))
    };

    UNSAFE_componentWillMount() {
        Api.get(CustomerEndpoints.list).then(({ data }) => store.dispatch({ type: SET_CUSTOMER_LIST, payload: data })).catch((e) => console.error(e));
    }

    render() {
        return (
            <DataTable
                title={"Search Customers"}
                data={
                    this.props.customers
                        .sort(
                            (a, b) => {
                                if (a.account_no > b.account_no) {
                                    return 1;
                                }
                                if (a.account_no < b.account_no) {
                                    return -1;
                                }
                                return 0;
                            }
                        )
                        .map(acc => [acc.id, acc.company, <AccountImage {...acc} />, acc.account_no, acc.name])
                }
                columns={columns}
                options={this.options}
            />
        );
    }
}

const mapStateToProps = (state) => ({ customers: state.customers.list })

export default connect(mapStateToProps)(SearchCustomer);
